<template>
    <AppMgrSettingCommonForAndroid ref="appMgrSettingCommonForAndroid"
                                   :getURLFunction="getURLFunction"
                                   :getAppFunction="getAppFunction" />
    <div class="setting-footer-box d-flex ms-auto" style="height: 56px; margin-top: 16px;">
        <div class="d-flex flex-row ms-auto"  style="height: 56px;">
            <button type="button"
                    class="btn-scv-blue btn-footer-size"
                    @click="onBtnApply">
                ＯＫ
            </button>
            <div style="width: 24px"></div>
            <button type="button"
                    class="btn-scv-white btn-footer-size"
                    @click="onBtnCancel">
                キャンセル
            </button>
            <div style="width: 16px"></div>
        </div>
    </div>
    <Loading ref="loading" :name="name" />
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import AppMgrSettingCommonForAndroid from '@/views/Mobile/AndroidAppDist/AppMgrSettingCommonForAndroid.vue';
    import axios, { AxiosResponse, CancelTokenSource } from 'axios'
    import Loading from '@/components/Loading.vue';

    // C#から受け取るJSONデータ(index.htmlで受け取っている。)
    declare const androidAppMngPolicyJson: string;
    declare const androidAppMngSkyPolicyJson: string;
    declare const completedSetAppMngPolicy: boolean;
    declare const frontEndURL: string;

    @Options({
        components: {
            AppMgrSettingCommonForAndroid,
            Loading,
        }
    })

    export default class AndroidPolicyView extends Vue {
        private intervalID = -1;

        /**
         * マウント後の処理
         */
        public async mounted(): Promise<void> {
            // ローディング表示開始
            const refObj: any = this.$refs;
            refObj.loading.startLoading();

            // C#から情報が渡ってきたことを検知するためにポーリングする。
            this.intervalID = setInterval(this.onInterval, 100);
        }

        private onInterval(): void {
            if (false == completedSetAppMngPolicy) {
                return;
            }

            // タイマーを止める。
            clearInterval(this.intervalID);
            this.intervalID = -1;

            // 共通コンポーネントにJSON文字列をセット
            const refObj: any = this.$refs;
            refObj.appMgrSettingCommonForAndroid.setAppPolicyJsonText([JSON.stringify(androidAppMngPolicyJson), JSON.stringify(androidAppMngSkyPolicyJson)]);

            // ローディング表示終了
            refObj.loading.stopLoading();
        }

        /**
         * @brief	OK処理
         */
        private onBtnApply() {
            // 共通コンポーネントから取得する。
            const refObj: any = this.$refs;
            const jsonTextList = refObj.appMgrSettingCommonForAndroid.getAppPolicyJsonText();
            if (jsonTextList.length < 2) {
                // ありえない
                return;
            }

            // WebView2へ適用通知
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.chrome.webview.hostObjects.AppMngJsListner.onApply(jsonTextList[0], jsonTextList[1])
        }

        /**
         * @brief	キャンセル処理
         */
        private onBtnCancel() {
            // WebView2へキャンセル通知
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.chrome.webview.hostObjects.AppMngJsListner.onCancel()
        }

        /**
         * Google Play の画面を使用するための URLを取得する
         */
        public async getURLFunction(): Promise<AxiosResponse> {
            // C#側で収集サーバーから取得してもらう。

            // URLのパスを作成する。
            var sendUrl = frontEndURL + "/android/AndroidManagedSotre";

            // 送信するbody情報(ParentFrameUrl)を作成する。
            var bodyData = {
                ParentFrameUrl: frontEndURL + "/android/appcfg",
            };

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            let response = await window.chrome.webview.hostObjects.AppMngJsListner.Post(sendUrl, JSON.stringify(bodyData), "application/json")
            if (null == response || '' == response) {
                const retInternalServerError: any = { status: 500 }
                return retInternalServerError;
            }

            // 取得結果からurlを取得する。
            let responseUrl = "";
            JSON.parse(response, (key, value) => {
                if (key === 'url') {
                    responseUrl = value;
                }
            });
            if ('' == responseUrl) {
                const retInternalServerError: any = { status: 500 }
                return retInternalServerError;
            }

            const ret: any = { status: 200, data: responseUrl }
            return ret;
        }

        /**
         * アプリケーション詳細情報を取得する
         */
        public async getAppFunction(packageName: string): Promise<AxiosResponse> {

            // URLのパスを作成する。
            var sendUrl = frontEndURL + "/android/ApplicationGet";

            // 送信するbody情報(PackageName)を作成する。
            var bodyData = {
                PackageName: packageName,
            };

            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            let response = await window.chrome.webview.hostObjects.AppMngJsListner.Post(sendUrl, JSON.stringify(bodyData), "application/json")
            if (null == response || '' == response) {
                const retInternalServerError: any = { status: 500 }
                return retInternalServerError;
            }

            const ret: any = { status: 200, data: JSON.parse(response), ContentType: "application/json" }
            return ret;
        }
    }
</script>

<style scoped>
    .scv-text-loading {
        font-size: 13px;
    }
</style>